// Keep this in sync with backend `_password_meets_policy` in server.py.
export const PASSWORD_RULES = [
  { key: "len", label: "At least 12 characters", test: (v) => v.length >= 12 },
  { key: "upper", label: "One uppercase letter", test: (v) => /[A-Z]/.test(v) },
  { key: "lower", label: "One lowercase letter", test: (v) => /[a-z]/.test(v) },
  { key: "num", label: "One number", test: (v) => /\d/.test(v) },
  { key: "sym", label: "One symbol", test: (v) => /[^A-Za-z0-9]/.test(v) },
];

export const PASSWORD_POLICY_MSG =
  "Password must be at least 12 characters and include an uppercase letter, a lowercase letter, a number, and a symbol.";

export const passwordMeetsPolicy = (v) => PASSWORD_RULES.every((r) => r.test(v || ""));
